import React from 'react';
import './special-page.scss';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import { connect } from 'react-redux';
import CustomTile from '../../components/common/CustomTile/CustomTile';
import { getSpecialPageSection } from 'hb-redux-store/feature/home/home.action';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';
import { DEVICE_TYPE } from 'hb-redux-store/util/constantServices';
import Icon from '../../components/mweb/Icon/Icon';
import { Link } from 'react-router-dom';
// const splPage = {
//   "action": "success",
//   "boutiqueList": [
//     {
//       "restTime": 0,
//       "id": 36828,
//       "name": "New Style All 5th SP",
//       "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/27ca8690-4de0-4521-8b27-3208836b295a_full.jpg?version=1596540905165",
//       "salePlanInventory": false,
//       "bestSeller": false,
//       "isSale": false,
//       "isNew": false,
//       "isLiveBoutique": false,
//       "brandId": 0,
//       "isPopularBrand": false,
//       "trackChildrenGroupSortAction": false,
//       "showInBoutiqueSetting": false,
//       "isImportant": false,
//       "preOrder": false,
//       "deliveryDays": 0,
//       "isRemind": false,
//       "isTile": 1,
//       "tileAction": "/collection/57517/Refresh+the+Wardrobe",
//       "isVirtualLabelsBrandBoutique": false,
//       "favourite": false,
//       "flexiImageWidth": 0,
//       "flexiImageHeight": 0,
//       "bannerImageWidth": 0,
//       "bannerImageHeight": 0,
//       "heroImageWidth": 0,
//       "heroImageHeight": 0,
//       "homepageImageWidth": 0,
//       "homepageImageHeight": 0,
//       "imageWidth": 320,
//       "imageHeight": 585,
//       "squareImageWidth": 0,
//       "squareImageHeight": 0,
//       "isDynamicCustomTile": false,
//       "tileType": "COLLECTION",
//       "showTileName": false,
//       "showPadding": false,
//       "tileGrid": [
//         {
//           "width": 320,
//           "height": 585,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/27ca8690-4de0-4521-8b27-3208836b295a_full.jpg?version=1596540905165",
//           "actionUri": "/collection/57517/Refresh+the+Wardrobe",
//           "action_type": "BOUTIQUE"
//         },
//         {
//           "width": 320,
//           "height": 585,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/c57242c9-d1e7-4bac-93f2-0456b6faa24b_full.jpg?version=1596540910372",
//           "actionUri": "/collection/57509/Refresh+the+Wardrobe",
//           "action_type": "BOUTIQUE"
//         },
//         {
//           "width": 320,
//           "height": 585,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/7865a8d6-2900-4721-9881-63c681fb93cd_full.jpg?version=1596540917020",
//           "actionUri": "/collection/57513/Refresh+the+Wardrobe",
//           "action_type": "BOUTIQUE"
//         }
//       ],
//       "customTilesId": 13440,
//       "priceDetail": "",
//       "region": ""
//     },
//     {
//       "restTime": 0,
//       "id": 36829,
//       "name": "New Style All 5th SP",
//       "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/11720792-e441-494b-ae04-3d3c15c7be8e_full.jpg?version=1596540932493",
//       "salePlanInventory": false,
//       "bestSeller": false,
//       "isSale": false,
//       "isNew": false,
//       "isLiveBoutique": false,
//       "brandId": 0,
//       "isPopularBrand": false,
//       "trackChildrenGroupSortAction": false,
//       "showInBoutiqueSetting": false,
//       "isImportant": false,
//       "preOrder": false,
//       "deliveryDays": 0,
//       "isRemind": false,
//       "isTile": 1,
//       "tileAction": "/products/11037/Toys",
//       "isVirtualLabelsBrandBoutique": false,
//       "favourite": false,
//       "flexiImageWidth": 0,
//       "flexiImageHeight": 0,
//       "bannerImageWidth": 0,
//       "bannerImageHeight": 0,
//       "heroImageWidth": 0,
//       "heroImageHeight": 0,
//       "homepageImageWidth": 0,
//       "homepageImageHeight": 0,
//       "imageWidth": 960,
//       "imageHeight": 747,
//       "squareImageWidth": 0,
//       "squareImageHeight": 0,
//       "isDynamicCustomTile": false,
//       "tileType": "COLLECTION",
//       "showTileName": false,
//       "showPadding": false,
//       "tileGrid": [
//         {
//           "width": 960,
//           "height": 747,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/11720792-e441-494b-ae04-3d3c15c7be8e_full.jpg?version=1596540932493",
//           "actionUri": "/products/11037/Toys",
//           "action_type": "SHOW_PRODUCT_LIST"
//         }
//       ],
//       "customTilesId": 13440,
//       "priceDetail": "",
//       "region": ""
//     },
//     {
//       "restTime": 0,
//       "id": 36830,
//       "name": "New Style All 5th SP",
//       "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/6d63113e-619b-4928-94b3-65b49c19a029_full.jpg?version=1596540945842",
//       "salePlanInventory": false,
//       "bestSeller": false,
//       "isSale": false,
//       "isNew": false,
//       "isLiveBoutique": false,
//       "brandId": 0,
//       "isPopularBrand": false,
//       "trackChildrenGroupSortAction": false,
//       "showInBoutiqueSetting": false,
//       "isImportant": false,
//       "preOrder": false,
//       "deliveryDays": 0,
//       "isRemind": false,
//       "isTile": 1,
//       "tileAction": "/products/11031/Hasbro+Toys",
//       "isVirtualLabelsBrandBoutique": false,
//       "favourite": false,
//       "flexiImageWidth": 0,
//       "flexiImageHeight": 0,
//       "bannerImageWidth": 0,
//       "bannerImageHeight": 0,
//       "heroImageWidth": 0,
//       "heroImageHeight": 0,
//       "homepageImageWidth": 0,
//       "homepageImageHeight": 0,
//       "imageWidth": 240,
//       "imageHeight": 237,
//       "squareImageWidth": 0,
//       "squareImageHeight": 0,
//       "isDynamicCustomTile": false,
//       "tileType": "COLLECTION",
//       "showTileName": false,
//       "showPadding": false,
//       "tileGrid": [
//         {
//           "width": 240,
//           "height": 237,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/6d63113e-619b-4928-94b3-65b49c19a029_full.jpg?version=1596540945842",
//           "actionUri": "/products/11031/Hasbro+Toys",
//           "action_type": "SHOW_PRODUCT_LIST"
//         },
//         {
//           "width": 240,
//           "height": 237,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/32b94806-137c-419a-8081-ed865dddfe38_full.jpg?version=1596540950732",
//           "actionUri": "/products/11032/Toys",
//           "action_type": "SHOW_PRODUCT_LIST"
//         },
//         {
//           "width": 240,
//           "height": 237,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/b0547ac0-4f3c-4ab7-817a-f298f60c5357_full.jpg?version=1596540954650",
//           "actionUri": "/collection/57372/yucky",
//           "action_type": "BOUTIQUE"
//         },
//         {
//           "width": 240,
//           "height": 237,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/627748d8-d1ef-4905-8492-f2d30773c6ba_full.jpg?version=1596540960786",
//           "actionUri": "/products/11179/boredom+busters",
//           "action_type": "SHOW_PRODUCT_LIST"
//         }
//       ],
//       "customTilesId": 13440,
//       "priceDetail": "",
//       "region": ""
//     },
//     {
//       "restTime": 0,
//       "id": 36831,
//       "name": "New Style All 5th SP",
//       "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/dbdf95ac-2d5c-461c-a66e-28b552a94605_full.jpg?version=1596540978750",
//       "salePlanInventory": false,
//       "bestSeller": false,
//       "isSale": false,
//       "isNew": false,
//       "isLiveBoutique": false,
//       "brandId": 0,
//       "isPopularBrand": false,
//       "trackChildrenGroupSortAction": false,
//       "showInBoutiqueSetting": false,
//       "isImportant": false,
//       "preOrder": false,
//       "deliveryDays": 0,
//       "isRemind": false,
//       "isTile": 1,
//       "tileAction": "/products/11015/Personal+Care",
//       "isVirtualLabelsBrandBoutique": false,
//       "favourite": false,
//       "flexiImageWidth": 0,
//       "flexiImageHeight": 0,
//       "bannerImageWidth": 0,
//       "bannerImageHeight": 0,
//       "heroImageWidth": 0,
//       "heroImageHeight": 0,
//       "homepageImageWidth": 0,
//       "homepageImageHeight": 0,
//       "imageWidth": 960,
//       "imageHeight": 653,
//       "squareImageWidth": 0,
//       "squareImageHeight": 0,
//       "isDynamicCustomTile": false,
//       "tileType": "COLLECTION",
//       "showTileName": false,
//       "showPadding": false,
//       "tileGrid": [
//         {
//           "width": 960,
//           "height": 653,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/dbdf95ac-2d5c-461c-a66e-28b552a94605_full.jpg?version=1596540978750",
//           "actionUri": "/products/11015/Personal+Care",
//           "action_type": "SHOW_PRODUCT_LIST"
//         }
//       ],
//       "customTilesId": 13440,
//       "priceDetail": "",
//       "region": ""
//     },
//     {
//       "restTime": 0,
//       "id": 36832,
//       "name": "New Style All 5th SP",
//       "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/09f85878-c46b-49bc-8cf8-b9f1c88d3310_full.jpg?version=1596540990788",
//       "salePlanInventory": false,
//       "bestSeller": false,
//       "isSale": false,
//       "isNew": false,
//       "isLiveBoutique": false,
//       "brandId": 0,
//       "isPopularBrand": false,
//       "trackChildrenGroupSortAction": false,
//       "showInBoutiqueSetting": false,
//       "isImportant": false,
//       "preOrder": false,
//       "deliveryDays": 0,
//       "isRemind": false,
//       "isTile": 1,
//       "tileAction": "/products/9514/The+Moms+Co",
//       "isVirtualLabelsBrandBoutique": false,
//       "favourite": false,
//       "flexiImageWidth": 0,
//       "flexiImageHeight": 0,
//       "bannerImageWidth": 0,
//       "bannerImageHeight": 0,
//       "heroImageWidth": 0,
//       "heroImageHeight": 0,
//       "homepageImageWidth": 0,
//       "homepageImageHeight": 0,
//       "imageWidth": 240,
//       "imageHeight": 245,
//       "squareImageWidth": 0,
//       "squareImageHeight": 0,
//       "isDynamicCustomTile": false,
//       "tileType": "COLLECTION",
//       "showTileName": false,
//       "showPadding": false,
//       "tileGrid": [
//         {
//           "width": 240,
//           "height": 245,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/09f85878-c46b-49bc-8cf8-b9f1c88d3310_full.jpg?version=1596540990788",
//           "actionUri": "/products/9514/The+Moms+Co",
//           "action_type": "SHOW_PRODUCT_LIST"
//         },
//         {
//           "width": 240,
//           "height": 245,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/e3f31399-bcf2-4353-9e13-9240976e4278_full.jpg?version=1596541003482",
//           "actionUri": "/products/9515/Mamaearth",
//           "action_type": "SHOW_PRODUCT_LIST"
//         },
//         {
//           "width": 240,
//           "height": 245,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/fcce5f05-91aa-4cde-94c5-852330f99f7c_full.jpg?version=1596541008507",
//           "actionUri": "/products/9845/Lotus",
//           "action_type": "SHOW_PRODUCT_LIST"
//         },
//         {
//           "width": 240,
//           "height": 245,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/d7fff3b6-fa89-4dfb-a357-ea04f8ed9cf1_full.jpg?version=1596541016223",
//           "actionUri": "/products/9516/Himalaya",
//           "action_type": "SHOW_PRODUCT_LIST"
//         }
//       ],
//       "customTilesId": 13440,
//       "priceDetail": "",
//       "region": ""
//     },
//     {
//       "restTime": 0,
//       "id": 36833,
//       "name": "New Style All 5th SP",
//       "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/e9d77702-d6a5-431b-884b-7d5d6cc2df32_full.gif?version=1596541035179",
//       "salePlanInventory": false,
//       "bestSeller": false,
//       "isSale": false,
//       "isNew": false,
//       "isLiveBoutique": false,
//       "brandId": 0,
//       "isPopularBrand": false,
//       "trackChildrenGroupSortAction": false,
//       "showInBoutiqueSetting": false,
//       "isImportant": false,
//       "preOrder": false,
//       "deliveryDays": 0,
//       "isRemind": false,
//       "isTile": 1,
//       "tileAction": "/products/11106/Limited+Time+Collection",
//       "isVirtualLabelsBrandBoutique": false,
//       "favourite": false,
//       "flexiImageWidth": 0,
//       "flexiImageHeight": 0,
//       "bannerImageWidth": 0,
//       "bannerImageHeight": 0,
//       "heroImageWidth": 0,
//       "heroImageHeight": 0,
//       "homepageImageWidth": 0,
//       "homepageImageHeight": 0,
//       "imageWidth": 480,
//       "imageHeight": 577,
//       "squareImageWidth": 0,
//       "squareImageHeight": 0,
//       "isDynamicCustomTile": false,
//       "tileType": "COLLECTION",
//       "showTileName": false,
//       "showPadding": false,
//       "tileGrid": [
//         {
//           "width": 480,
//           "height": 577,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/e9d77702-d6a5-431b-884b-7d5d6cc2df32_full.gif?version=1596541035179",
//           "actionUri": "/products/11106/Limited+Time+Collection",
//           "action_type": "SHOW_PRODUCT_LIST"
//         },
//         {
//           "width": 480,
//           "height": 577,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/833ac7c7-905c-47ba-81ef-5184d1f413ed_full.gif?version=1596541046664",
//           "actionUri": "/products/11106/Limited+Time+Collection",
//           "action_type": "SHOW_PRODUCT_LIST"
//         }
//       ],
//       "customTilesId": 13440,
//       "priceDetail": "",
//       "region": ""
//     },
//     {
//       "restTime": 0,
//       "id": 36834,
//       "name": "New Style All 5th SP",
//       "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/20535455-1b87-4b8a-a6d5-105475559135_full.jpg?version=1596541073366",
//       "salePlanInventory": false,
//       "bestSeller": false,
//       "isSale": false,
//       "isNew": false,
//       "isLiveBoutique": false,
//       "brandId": 0,
//       "isPopularBrand": false,
//       "trackChildrenGroupSortAction": false,
//       "showInBoutiqueSetting": false,
//       "isImportant": false,
//       "preOrder": false,
//       "deliveryDays": 0,
//       "isRemind": false,
//       "isTile": 1,
//       "tileAction": "/products/11024/Value+Packs+Under+599",
//       "isVirtualLabelsBrandBoutique": false,
//       "favourite": false,
//       "flexiImageWidth": 0,
//       "flexiImageHeight": 0,
//       "bannerImageWidth": 0,
//       "bannerImageHeight": 0,
//       "heroImageWidth": 0,
//       "heroImageHeight": 0,
//       "homepageImageWidth": 0,
//       "homepageImageHeight": 0,
//       "imageWidth": 480,
//       "imageHeight": 590,
//       "squareImageWidth": 0,
//       "squareImageHeight": 0,
//       "isDynamicCustomTile": false,
//       "tileType": "COLLECTION",
//       "showTileName": false,
//       "showPadding": false,
//       "tileGrid": [
//         {
//           "width": 480,
//           "height": 590,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/20535455-1b87-4b8a-a6d5-105475559135_full.jpg?version=1596541073366",
//           "actionUri": "/products/11024/Value+Packs+Under+599",
//           "action_type": "SHOW_PRODUCT_LIST"
//         },
//         {
//           "width": 480,
//           "height": 590,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/db14ee52-fb4d-4466-8abf-13ec2215c599_full.jpg?version=1596541078730",
//           "actionUri": "/collection/57474/All+Under+399",
//           "action_type": "BOUTIQUE"
//         }
//       ],
//       "customTilesId": 13440,
//       "priceDetail": "",
//       "region": ""
//     },
//     {
//       "restTime": 0,
//       "id": 36835,
//       "name": "New Style All 5th SP",
//       "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/66d696bb-f6f9-4fbb-8014-1e8347614d14_full.jpg?version=1596541097430",
//       "salePlanInventory": false,
//       "bestSeller": false,
//       "isSale": false,
//       "isNew": false,
//       "isLiveBoutique": false,
//       "brandId": 0,
//       "isPopularBrand": false,
//       "trackChildrenGroupSortAction": false,
//       "showInBoutiqueSetting": false,
//       "isImportant": false,
//       "preOrder": false,
//       "deliveryDays": 0,
//       "isRemind": false,
//       "isTile": 1,
//       "tileAction": "/collections/New_Styles_For_Your_Baby_Girl",
//       "isVirtualLabelsBrandBoutique": false,
//       "favourite": false,
//       "flexiImageWidth": 0,
//       "flexiImageHeight": 0,
//       "bannerImageWidth": 0,
//       "bannerImageHeight": 0,
//       "heroImageWidth": 0,
//       "heroImageHeight": 0,
//       "homepageImageWidth": 0,
//       "homepageImageHeight": 0,
//       "imageWidth": 240,
//       "imageHeight": 643,
//       "squareImageWidth": 0,
//       "squareImageHeight": 0,
//       "isDynamicCustomTile": false,
//       "tileType": "COLLECTION",
//       "showTileName": false,
//       "showPadding": true,
//       "tileGrid": [
//         {
//           "width": 240,
//           "height": 643,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/66d696bb-f6f9-4fbb-8014-1e8347614d14_full.jpg?version=1596541097430",
//           "actionUri": "/collections/New_Styles_For_Your_Baby_Girl",
//           "action_type": "SPECIAL_PAGE"
//         },
//         {
//           "width": 240,
//           "height": 643,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/2579b976-5002-4ae2-8d93-b32b1a591e81_full.jpg?version=1596541105665",
//           "actionUri": "/collections/New_Styles_For_Your_Baby_Boy",
//           "action_type": "SPECIAL_PAGE"
//         },
//         {
//           "width": 240,
//           "height": 643,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/00773c0b-d4a5-4d6a-88cf-20326f100c19_full.jpg?version=1596541110522",
//           "actionUri": "/collections/New_Styles_For_Your_Boy",
//           "action_type": "SPECIAL_PAGE"
//         },
//         {
//           "width": 240,
//           "height": 643,
//           "imageUrl": "https://static.hopscotch.in/fstatic/product/202008/6bcd334d-e534-4a54-b39d-7f535bf0d7a7_full.jpg?version=1596541115369",
//           "actionUri": "/collections/New_Styles_For_Your_Girl",
//           "action_type": "SPECIAL_PAGE"
//         }
//       ],
//       "customTilesId": 13440,
//       "priceDetail": "",
//       "region": ""
//     }
//   ],
//   "boutiqueTotalCount": 10,
//   "name": "new_styles_for_your_kid",
//   "page_id": 1058
// }
class SpecialPage extends React.Component {
  componentDidMount() {
    const { pageName } = this.props.match.params;
    this.props.getSpecialPageSection({
      pageName: pageName.substr(0, pageName.length - 4),
    });
    this.isDesktop = getDeviceType() === DEVICE_TYPE.DESKTOP;
  }

  render() {
    // const title = 'Welcome to special page';
    const { loading, specialPageSection } = this.props;
    // const ctData = specialPageSection?.sections[0]?.sectionData[0];
    return (
      <div className="special-page">
        {!this.isDesktop && <SecondaryNav />}
        {loading && <Loader />}
        {!specialPageSection?.error &&
          specialPageSection?.sections?.length > 0 &&
          specialPageSection?.sections.map((ct, index) => (
            <CustomTile
              ct={ct.sectionData[0]}
              source="specialPage"
              key={index}
            />
          ))}
        {specialPageSection?.error && (
          <div className="special-page--error">
            <Icon class="icon-empty-offers" width={180} height={133} />
            <div className="special-page--error--description">
              You landed on an invalid page.
              <br />
              Explore our site to check on lip-smacking food items.
            </div>
            <Link to="/" className="button button-primary">
              Explore Products
            </Link>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ homeReducer }) => ({
  specialPageSection: homeReducer.specialPageSection,
  loading: homeReducer.loading,
});
const mapDispatchToProps = { getSpecialPageSection };

export default connect(mapStateToProps, mapDispatchToProps)(SpecialPage);
